type Listener = () => void;

const listeners = new Set<Listener>();

export function onAgentAbort(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function notifyAgentAbort(): void {
  for (const fn of [...listeners]) {
    try {
      fn();
    } catch (err) {
      console.warn('[agent] abort listener threw', err);
    }
  }
}
